import { Container, Sprite, Assets, Graphics, TexturePool } from "pixi.js"


TexturePool.textureOptions.scaleMode = 'linear';

type Options = {
  url: string;
  width: number;
  height: number;
  backgroundSize?: 'cover' | 'contain';
  crop?: boolean;
};

export default class Image extends Container {

  private _options: Options;
  private _graphics: Graphics;
  public sprite: Sprite;

  constructor(options: Options) {
    super()
    this._options = Object.assign({
      backgroundSize: 'cover'
    }, options);

    this.createSprite();
  }

  async createSprite() {
    const { url, width, height, crop } = this._options;

    await Assets.load(url);

    // console.log('[Image]', { url })
    this.sprite = Sprite.from(url, false);
    // this.sprite.texture.source.scaleMode = "nearest";
    this.sprite.texture.source.scaleMode = "linear";
    this.sprite.texture.source.update();
    
    this.sprite.anchor.set(0.5)
    this.sprite.x = width / 2;
    this.sprite.y = height / 2;

    this.addChild(this.sprite)

    this.onResize();
    if (crop) {
      this.createMask();
    }
  }

  onResize() {
    const { width, height, backgroundSize } = this._options;
    const { width: textureW, height: textureH } = this.sprite.texture.source;
    const ratio = height / width;
    const textureRatio = textureH / textureW;
    
    const test = backgroundSize === 'cover' ? ratio <= textureRatio : ratio >= textureRatio;
    // console.log('scaleW', width / textureW);
    // console.log('scaleH', height / textureH);
    
    const scale = Math.round(((test) ? width / textureW : height / textureH) * 100) / 100;
    // console.log('texture', { ratio, textureRatio, backgroundSize, scale });
    
    this.sprite.scale.set(scale);
  }
  updateSize(width: number, height: number) {
    this._options.width = width;
    this._options.height = height;

    this.sprite.x = width / 2;
    this.sprite.y = height / 2;

    this.drawMask();
    this.onResize();
  }

  createMask() {
    this._graphics = new Graphics();
    const graphics = this._graphics;

    this.drawMask();

    this.addChild(graphics);
    this.sprite.mask = graphics;
  }
  drawMask() {
    const graphics = this._graphics;
    if (graphics) {
      const { width, height } = this._options;
  
      graphics.clear();
      graphics.beginPath();
      graphics.rect(0, 0, width, height);
      graphics.fill(0xff0000);
      graphics.closePath();
    }
  }
}